import { quadOut } from 'svelte/easing';
function updateTextContent(elem, value, elemTextObj) {
    const localeStringOptions = {
        minimumFractionDigits: elemTextObj.decimalPlaces,
        maximumFractionDigits: elemTextObj.decimalPlaces
    };
    elem.textContent =
        elemTextObj.leadingChars +
            Math.abs(Number(value)).toLocaleString(undefined, localeStringOptions) +
            elemTextObj.endingChars;
}
export function animateNumber(elem, { startValue, endValue }) {
    if (elem.textContent === null) {
        return;
    }
    const duration = 500;
    const numberString = elem.textContent.match(/[0-9]*\.?[0-9]+/g).join("");
    const isDecimalNumber = numberString.indexOf(".") !== -1 ? true : false;
    const elemTextObj = {
        leadingChars: elem.textContent.match(/^[^0-9.]*/g).join(""),
        endingChars: elem.textContent.match(/[^0-9]*$/g).join(""),
        decimalPlaces: isDecimalNumber
            ? numberString.length - 1 - numberString.lastIndexOf(".")
            : 0
    };
    return {
        duration,
        css: (t) => {
            const eased = quadOut(t);
            return `transform: scale(${Math.abs((eased * 2) - 3)}) translateY(-${Math.abs((eased * 10) - 10)}px);
            opacity: ${eased * 1};`;
        },
        tick: (t) => {
            const newValue = startValue + Math.trunc((endValue - startValue) * t);
            updateTextContent(elem, newValue, elemTextObj);
        }
    };
}
